import {StyleSheet} from 'react-native';

export const TextStyles = StyleSheet.create({
  textSecondaryHeading5xl: {
    fontFamily: 'CircularStd-Book',
    fontWeight: '700',
    fontSize: 52,
    lineHeight: 70,
  },
  textHeadingXl: {
    fontFamily: 'CircularStd-Bold',
    fontWeight: '700',
    fontSize: 21,
    lineHeight: 35,
    textAlign: 'center',
  },
  textBlock: {
    fontSize: 15,
    fontWeight: '600',
  },
  textXS: {
    fontFamily: 'CircularStd-Book',
    fontSize: 13,
    fontWeight: '400',
    lineHeight: 15,
  },
  textS: {
    fontFamily: 'CircularStd-Book',
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 20,
  },
  textMediumXS: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 13,
    fontWeight: '400',
    lineHeight: 15,
  },
  textMediumXSBold: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 13,
    fontWeight: '700',
    lineHeight: 15,
  },
  textMediumS: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 20,
  },
  textMediumM: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 17,
    fontWeight: '400',
    lineHeight: 20,
  },
  textMediumMBold: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 17,
    fontWeight: '700',
    lineHeight: 20,
  },
  textMediumL: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 19,
    fontWeight: '400',
    lineHeight: 30,
  },
  textMediumXL: {
    fontFamily: 'CircularStd-Medium',
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 25,
  },
});
